import type { AnyEventObject, AnyMachineSnapshot } from 'xstate';
import { getNextSnapshot, assign } from 'xstate';

import { getMeta } from 'machines/utils/misc';

export const actions = {
  updateContextGuards: assign({
    guards: ({ event, context }) => ({ ...context.guards, ...event.guards })
  }),
  navigate: async ({
    event,
    context
  }: {
    event: AnyEventObject;
    context: unknown;
  }) => {
    const { payload, type } = event;
    if (!payload) {
      return;
    }

    const { callback, actor } = payload;
    const state: AnyMachineSnapshot | undefined = actor?.getSnapshot();

    /* istanbul ignore else -- @preserve */
    if (state && typeof callback === 'function') {
      const { machine, value } = state;
      const nextState = getNextSnapshot(
        machine,
        machine.resolveState({ value, context }),
        {
          type,
          payload
        }
      );

      const { path } = getMeta(nextState);

      await callback({ path });

      return path;
    }
  }
};
